import { compose, withHandlers } from 'recompose';

import ShipperOrderTableGroup from './component';

const enhance = compose(
  withHandlers({
    onLoadMore:
      ({
        onLoadMore = () => {
          /*noop*/
        },
      }) =>
      (numberOfPage) => {
        onLoadMore(numberOfPage);
      },
  })
);

export default enhance(ShipperOrderTableGroup);
